import React from "react";
import "./WhyChooseUs.css";
// Verbatim image filename reference from your request
import wcuBannerImage from "../assets3/why_choose_us.png"; 

// Custom inline SVGs representing the design's iconography
const TechIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);

const SpeedIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
  </svg>
);

const PriceIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
    <line x1="12" y1="1" x2="12" y2="23"></line>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
  </svg>
);

const PartsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const HappyIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="24" height="24">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const WhyChooseUs = () => {
  const features = [
    {
      icon: <TechIcon />,
      title: "Experienced Technicians",
      desc: "Skilled professionals specialized in troubleshooting complex washing machine issues."
    },
    {
      icon: <SpeedIcon />,
      title: "Fast Doorstep Service",
      desc: "Prompt response and same-day inspection available directly at your home."
    },
    {
      icon: <PriceIcon />,
      title: "Affordable Pricing",
      desc: "Transparent and budget-friendly repair charges with completely honest rates."
    },
    {
      icon: <PartsIcon />,
      title: "Quality Spare Parts",
      desc: "We use high-grade, durable replacement components for reliable, long-lasting fixes."
    },
    {
      icon: <HappyIcon />,
      title: "Customer Satisfaction",
      desc: "Our primary objective is delivering exceptional, hassle-free laundry machine service."
    },
    {
      icon: <ClockIcon />,
      title: "Flexible Service Timing",
      desc: "Convenient appointment slots tailored entirely around your daily routine."
    }
  ];

  return (
    <section className="jabh-wcu-section">
      <div className="jabh-wcu-container">
        
        {/* Left Aspect: Introductory Column Layout */}
        <div className="jabh-wcu-intro-col">
          <span className="jabh-wcu-tag">WHY CHOOSE US?</span>
          <h2 className="jabh-wcu-title">What Sets Us Apart</h2>
          <p className="jabh-wcu-lead-text">
            We provide quick, dependable, and cost-effective washing machine repair 
            services with skilled local technicians, quality spare parts, transparent 
            pricing, and a strong commitment to keeping your home running smoothly.
          </p>
          
          <div className="jabh-wcu-banner-wrapper">
            <img 
              src={wcuBannerImage} 
              alt="Why Choose Us infographic layout highlighting features" 
              className="jabh-wcu-banner-img"
            />
          </div>
        </div>

        {/* Right Aspect: Modular Features Columns */}
        <div className="jabh-wcu-features-grid">
          {features.map((item, idx) => (
            <div key={idx} className="jabh-wcu-feature-item">
              <div className="jabh-wcu-icon-box">
                {item.icon}
              </div>
              <div className="jabh-wcu-feature-content">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;